<app-content-container [error]="billingStepError$ | async">
  <div class="grid">
    <app-wizard-order-summary
      *ngIf="(isLgAndAbove$ | async) !== true"
      [isConfirmationTouched]="isConfirmationTouched"
      [(confirmDeductibleOverrides)]="confirmDeductibleOverrides"
      class="block col-12"
    ></app-wizard-order-summary>
    <div class="col-12 lg:col-7">
      <div class="mb-5">
        <app-payment-method
          (editModeChange)="onEditModeChange($event)"
          [isPaymentMethodTouched]="isPaymentMethodTouched"
        ></app-payment-method>
      </div>
      <p-card data-cy="product-summary-container">
        <h3 class="mt-0 mb-3 sm:mb-4">Products</h3>
        <app-product-details [items]="(reorderItemsSummary$ | async) || []"></app-product-details>
      </p-card>
    </div>
    <app-wizard-order-summary
      *ngIf="isLgAndAbove$ | async"
      [isConfirmationTouched]="isConfirmationTouched"
      [(confirmDeductibleOverrides)]="confirmDeductibleOverrides"
      class="block col-5"
    ></app-wizard-order-summary>
  </div>
  <app-wizard-footer
    [submitForm]="onSubmit.bind(this)"
    [disableNav]="editMode || (updateCopayDeductibleOverridesState$ | async)?.isLoading || isProcessingPayment"
    [nextLabel]="isProcessingPayment ? 'Processing...' : null"
  ></app-wizard-footer>
</app-content-container>

<app-notification-overlay
  [(visible)]="displayPaymentError"
  title="Payment Failed"
  message="An error occured while submitting your payment. Please review your information and try submitting again."
  type="error"
  (dismiss)="paymentFailedNotificationDismissed()"
></app-notification-overlay>

<app-notification-overlay
  [(visible)]="displayPaymentSuccess"
  title="Payment Successful"
  message="Thank you for your payment!"
  type="success"
  (dismiss)="paymentSuccessNotificationDismissed()"
></app-notification-overlay>

<app-notification-overlay
  [(visible)]="displayHealthSavingsAccountModal"
  title="Your payment method has been added!"
  message="Once we receive an explanation of benefits (EOB) from your insurance, we will contact you to confirm the exact amount that will be charged to your Health Savings Account (HSA)."
  type="success"
  (dismiss)="healthSavingsAccountModalDismissed()"
></app-notification-overlay>

<app-notification-overlay
  [(visible)]="displayShipmentReleaseError"
  title="Order Submission Failed"
  message="An error occured while submitting your order. Please review your information and try submitting again."
  [additionalDetails]="'Error Details: ' + shipmentReleaseErrorMessage"
  type="error"
  (dismiss)="shipmentReleaseErrorDismissed()"
></app-notification-overlay>
